export default {"src":"/pages/_next/static/media/icon-bot-new.2214b045.svg","height":48,"width":47,"blurWidth":0,"blurHeight":0};